import {
  isMemberRestricted,
  hasfullTdMembersAccess,
  hasLimitedPhiAccess,
  hasLimitedPiAccess,
  hasImpersonationAccess,
  isAdult
} from '../Utils';
import { get, compact } from 'lodash';
import getClientInstance from '../config/apollo-client';
import MEMBERS_SEARCH from './queries/member-search.js';

import unmaskedMember from './members/unmasked-member';
import restrictedMember from './members/restricted-member';
import unmaskedPendingMember from './members/unmasked-pending-member';
import restrictedPendingMember from './members/restricted-pending-member';

const findMembersAndBenefits = (filters, options)  => {
  const client = getClientInstance();
  const phoneNumberInput = get(filters, 'phoneNumber', '');
  const phoneNumber = phoneNumberInput.substring(3);
  const areaCode = phoneNumberInput.substring(0, 3);

  const searchParams = {
    firstName:        filters.firstName,
    lastName:         filters.lastName,
    zipCode:          filters.zipCode,
    phoneNumber,
    areaCode,
    emailAddress:     filters.emailAddress,
    memberId:         parseInt(filters.memberId),
    sourceMemberId:   filters.healthPlanId,
    userName:         filters.username,
    benefitGroupName: filters.groupName,
    dob:              filters.dob,
    mrnId:            parseInt(filters.mrnId),
  };
  const variables = {
    searchParams,
    exactSearch:  true,
    onlyPending:  true,
    partialMatch: true,
    ...options
  };
  return client
    .query({
      fetchPolicy: 'no-cache',
      variables: variables,
      query: MEMBERS_SEARCH
    }).then(r => {
      const searchData = r.data.membersSearch;
      let accounts = searchData.activeMembers
                        .map(member => {
                          try {
                            const restricted = isMemberRestricted(get(member, 'mrns', []).map(benefit => benefit.group.id));
                            const canImpersonate = hasImpersonationAccess() || hasfullTdMembersAccess(restricted);
                            const canResetPassword = (!restricted || hasLimitedPiAccess(restricted) || hasLimitedPhiAccess(restricted)) && isAdult(member.dateOfBirth);
                            const restrictions = {
                              canImpersonate,
                              canResetPassword,
                              registered:          true,
                              hasLimitedPhiAccess: hasLimitedPhiAccess(restricted),
                              hasLimitedPiAccess:  hasLimitedPiAccess(restricted)
                            };
                            if (hasfullTdMembersAccess(restricted)) {
                              restrictions.canResetPassword = true;
                              return unmaskedMember(member, restrictions);
                            }
                            return restrictedMember(member, restrictions);
                          } catch (e) {
                              return null;
                          }
                        });
      accounts = compact(accounts);
      let possibleBenefits = searchData.eligibilityMembers
                                  .map(member => {
                                    try {
                                      const restricted = isMemberRestricted(get(member, 'mrns', []).map(benefit => benefit.group.id));
                                      const canImpersonate = !restricted && hasImpersonationAccess();
                                      const canResetPassword = (!restricted || hasLimitedPiAccess(restricted) || hasLimitedPhiAccess(restricted)) && isAdult(member.dateOfBirth);
                                      const restrictions = {
                                        canImpersonate,
                                        canResetPassword,
                                        registered:          false,
                                        hasLimitedPhiAccess: hasLimitedPhiAccess(restricted),
                                        hasLimitedPiAccess:  hasLimitedPiAccess(restricted),
                                        canViewProfileBtn:   document.querySelector("meta[property='featureToggles:mvpNewMemberProfile']").getAttribute('content') === 'true'
                                      };
                                      if (hasfullTdMembersAccess(restricted)) {
                                        return unmaskedPendingMember(member, restrictions);
                                      }
                                      return restrictedPendingMember(member, restrictions);
                                    } catch (e) {
                                        return null;
                                    }
                                  });
      possibleBenefits = compact(possibleBenefits);
      const results = accounts.concat(possibleBenefits);
      const meta = {
        activeTotal:  searchData.activeTotal,
        pendingTotal: searchData.eligibilityTotal,
        strategy:     'graphql_call'
      };
      return { results, meta };
    }).catch(e => {
      if (get(e, 'networkError.statusCode') == 401) {
        return eval(e.networkError.bodyText);
      }
      return { results: [], meta: {}, error: 'Failed to search' };
    });
};

const findMembers = (filters, options) => findMembersAndBenefits(filters, options)
                                .catch(_ => ({ results: [], meta: {}, error: 'Failed to search' }));

export default findMembers;
